import { cond, includes, prop, T } from 'ramda';
import { errorMessage } from '../utils/messageMutation';
import DefineActiveTeamMutation from '../_graphql/mutations/teams/DefineActiveTeamMutation';

// do not remove '/empty' path, it's used to force a re-render of the component when the user change his team
// https://stackoverflow.com/questions/47602091/how-to-use-react-router-4-0-to-refresh-current-route-not-reload-the-whole-page
export const historyPushWithReRender = (history, path) => {
  history.push('/empty');
  history.replace(path);
};

export const onDefineActiveTeam = ({ teamId, user, history, pathname, setIsLoading, setSelectedTeam }) => {
  setSelectedTeam(teamId);
  setIsLoading(true);
  // The mutation returns the full `userTeam` (roles, name, apiKey, members),
  // which Relay merges synchronously into the shared record. No userRefetch is
  // needed: a team switch never mutates `user` or the `teams` list server-side.
  DefineActiveTeamMutation({ teamId, userId: prop('userId', user) }, (ok, error) => {
    if (!ok || error) errorMessage();
    setIsLoading(false);
    cond([
      [includes('/offre'), () => historyPushWithReRender(history, '/')],
      [includes('/trames'), () => historyPushWithReRender(history, '/trames')],
      [includes('/equipe'), () => historyPushWithReRender(history, '/equipe')],
      [includes('/modeles'), () => historyPushWithReRender(history, '/modeles')],
      [T, () => historyPushWithReRender(history, '/')]
    ])(pathname);
  });
};
